import type { TUserRole } from '@/shared/types/common';

export const selectUserRole = (state: RootState): TUserRole => state.profile.role;
